<template>
  <div id="instructionDetailView">
    <div v-if="$route.name === 'instruction'">
      <h1>{{ $t('privatePage.instruction_add_header') }}</h1>
      <b-tabs>
        <b-tab :title="$t('privatePage.details')" active>
          <instructions-detail-editor v-on:onSubmit="onSubmitDetails" v-on:onDeleteInstruction="onDeleteInstruction" v-on:onDeleteTranslation="onDeleteTranslation" v-on:onAddTranslation="onAddTranslation" :currentInstruction="currentInstruction" :languages="languages" :selectedCulture="selectedCulture">
          </instructions-detail-editor>
        </b-tab>
        <b-tab :title="$t('privatePage.pageIndex_header', { page: pageIndex +1 })" v-for="(page, pageIndex) in currentInstruction.pages" :key="pageIndex">
          <instructions-page-editor v-on:onSubmit="onSubmitPage" v-on:onDeletePage="onDeletePage" :currentPage="page" :languages="languages" :selectedCulture="selectedCulture" :questionFormatId="currentInstruction.questionFormatId">
          </instructions-page-editor>
        </b-tab>
        <template #tabs-end>
          <b-nav-item @click.prevent="newTab" href="#" v-if="currentInstruction.id">
            +
          </b-nav-item>
        </template>
      </b-tabs>
    </div>
    <div v-else>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import InstructionsDetailEditor from '../../components/instructions/instructionsdetaileditor'
import InstructionsPageEditor from '../../components/instructions/instructionspageeditor'
import misc from '../../js/helpers/misc'
import editorFuncs from '../../components/scales/questions/questioneditorfuncs'

function createPage(counter) {
  return {
    id: '',
    translations: [],
    question: editorFuncs.createQuestion(),
    pageNum: counter,
    disableQuestion: false
  }
}

function createPageTranslation(languageId, isHidden) {
  return {
    id: '',
    languageId: languageId,
    text: '',
    text2: '',
    correctAnswerFeedback: '',
    wrongAnswerFeedback: '',
    emptyAnswerFeedback: '',
    translatedQuestion: editorFuncs.createQuestion(),
    isHidden: isHidden
  }
}

function createTranslation(languageId) {
  return {
    id: '',
    languageId: languageId
  }
}

export default {
  components: {
    InstructionsDetailEditor,
    InstructionsPageEditor
  },
  name: 'instructions-detail-view',
  computed: {
    ...mapGetters(['languages', 'selectedCulture']),
    ...mapGetters('instructionsModule', ['currentInstruction']),
    submitMessage() {
      return this.$t('save_ok_feedback')
    },
    deleteInstructionConfirmationMessage() {
      return this.$t('privatePage.instructionDelete_confirmation')
    },
    deleteInstructionMessage() {
      return this.$t('privatePage.instructionDelete_message')
    },
    deleteTranslationMessage() {
      return this.$t('privatePage.translationDelete_message')
    },
    deleteTranslationConfirmationMessage() {
      return this.$t('privatePage.translationDelete_confirmation')
    },
    deletePageConfirmationMessage() {
      return this.$t('privatePage.pageDelete_confirmation')
    }
  },
  methods: {
    ...mapActions({
      showSuccessMessage: 'showSuccessMessage',
      showErrorMessage: 'showErrorMessage'
    }),
    ...mapActions('instructionsModule', {
      getAllInstructions: 'getAllInstructions',
      saveInstructionDetails: 'saveInstructionDetails',
      deleteInstruction: 'deleteInstruction',
      savePage: 'savePage',
      deletePage: 'deletePage',
      deleteTranslation: 'deleteTranslation',
      getInstruction: 'getInstruction'
    }),
    newTab() {
      let page = createPage(this.maxPageNum++)

      if (this.currentInstruction.translations === undefined) {
        this.currentInstruction.translations = []
      }

      this.currentInstruction.translations.forEach(translation => {
        page.translations.push(
          createPageTranslation(translation.languageId, false)
        )
      })

      if (this.currentInstruction.pages === undefined) {
        this.currentInstruction.pages = []
      }

      this.currentInstruction.pages.push(page)
    },
    onSubmitDetails: function() {
      this.currentInstruction.selectedLanguageId = this.selectedCulture.languageId

      this.saveInstructionDetails(this.currentInstruction)
        .then(() => {
          this.getAllInstructions().then(() => {
            this.showSuccessMessage(this.submitMessage)
          })
        })
        .catch(error => {
          this.showErrorMessage(error)
        })
    },
    onDeleteInstruction: function() {
      if (window.confirm(this.deleteInstructionConfirmationMessage)) {
        this.deleteInstruction(this.currentInstruction)
          .then(() => {
            window.alert(this.deleteInstructionMessage)
            this.$router.go(-1)
          })
          .catch(error => {
            this.showErrorMessage(error)
          })
      }
    },
    onSubmitPage: function(page) {
      let pageInfo = { page: page, instruction: this.currentInstruction }

      this.savePage(pageInfo)
        .then(() => {
          this.showSuccessMessage(this.submitMessage)
        })
        .catch(error => {
          this.showErrorMessage(error)
        })
    },
    onDeletePage: function(page) {
      if (window.confirm(this.deletePageConfirmationMessage)) {
        let index = misc.getIndexInCollection(
          'id',
          page.id,
          this.currentInstruction.pages
        )

        if (index > -1 && page.id) {
          this.deletePage({
            instructionId: this.currentInstruction.id,
            pageId: page.id
          })
            .then(() => {
              this.getInstruction({
                instructionId: this.currentInstruction.id,
                languageId: this.selectedCulture.languageId
              })
                .then(() => {
                  this.showSuccessMessage(this.deleteTranslationMessage)
                })
                .catch(error => {
                  this.showErrorMessage(error)
                })
            })
            .catch(error => {
              this.showErrorMessage(error)
            })
        } else {
          index = misc.getIndexInCollection(
            'pageNum',
            page.pageNum,
            this.currentInstruction.pages
          )

          if (index !== -1) {
            this.currentInstruction.pages.splice(index, 1)
          }
        }
      }
    },
    onDeleteTranslation: function(translation) {
      if (window.confirm(this.deleteTranslationConfirmationMessage)) {
        this.deleteTranslation(translation)
          .then(() => {
            if (this.currentInstruction.id) {
              this.getInstruction({
                instructionId: this.currentInstruction.id,
                languageId: this.selectedCulture.languageId
              })
                .then(() => {
                  this.showSuccessMessage(this.deleteTranslationMessage)
                })
                .catch(error => {
                  this.showErrorMessage(error)
                })
            } else {
              this.showSuccessMessage(this.deleteTranslationMessage)
            }
          })
          .catch(error => {
            this.showErrorMessage(error)
          })
      }
    },
    onAddTranslation: function(languageId) {
      if (this.currentInstruction.translations === undefined) {
        this.currentInstruction.translations = []
      }

      let translationIndex = misc.getIndexInCollection(
        'languageId',
        languageId,
        this.currentInstruction.translations
      )

      if (translationIndex === -1) {
        this.currentInstruction.translations.push(createTranslation(languageId))
      }

      if (this.currentInstruction.pages === undefined) {
        this.currentInstruction.pages = []
      }

      this.currentInstruction.pages.forEach(page => {
        if (page.translations === undefined) {
          page.translations = []
        }

        translationIndex = misc.getIndexInCollection(
          'languageId',
          languageId,
          page.translations
        )

        if (translationIndex === -1) {
          page.translations.push(createPageTranslation(languageId, true))
        }
      })
    },
    getPageIdentifier: function(page) {
      if (page.id) {
        return page.id
      }
      return `pid:${this.maxPageNum++}`
    }
  },
  data() {
    return {
      maxPageNum: 0
    }
  },
  created() {
    if (!this.currentInstruction.id) {
      if (
        this.currentInstruction.translations === undefined ||
        (this.currentInstruction.translations !== undefined &&
          this.currentInstruction.translations.length === 0)
      ) {
        this.onAddTranslation(this.selectedCulture.languageId)
      }
    } else {
      if (
        this.currentInstruction.pages &&
        this.currentInstruction.pages.constructor === Array
      ) {
        this.currentInstruction.pages.forEach(page => {
          this.maxPageNum =
            page.pageNum > this.maxPageNum ? page.pageNum : ++this.maxPageNum
        })
      }
    }
  }
}
</script>
